export const Messages = {
  UnexpectedToken: 'Unexpected token %0',
  UnexpectedTokenIllegal: 'Unexpected token ILLEGAL',
}
